import config from '@/config';
import { errorPageDetailsConstant as deAtErrorPageDetails } from '@/constants/error-page-details/de-at/errorPageDetailsConstant';
import { errorPageDetailsConstant as enErrorPageDetails } from '@/constants/error-page-details/en/errorPageDetailsConstant';
import { errorPageDetailsConstant as esErrorPageDetails } from '@/constants/error-page-details/es/errorPageDetailsConstant';
import { errorPageDetailsConstant as itErrorPageDetails } from '@/constants/error-page-details/it/errorPageDetailsConstant';
import { errorPageDetailsConstant as jaJpErrorPageDetails } from '@/constants/error-page-details/ja-jp/errorPageDetailsConstant';
import { errorPageDetailsConstant as ruRuErrorPageDetails } from '@/constants/error-page-details/ru-ru/errorPageDetailsConstant';
import { getLocale } from '@/utils';

export const determineErrorPageDetails = () => {
  const locale = getLocale(config);
  switch (locale) {
    case 'es-es':
      return esErrorPageDetails;
    case 'it-it':
      return itErrorPageDetails;
    case 'de-at':
      return deAtErrorPageDetails;
    case 'ja-jp':
      return jaJpErrorPageDetails;
    case 'ru-ru':
      return ruRuErrorPageDetails;
    default:
      return enErrorPageDetails;
  }
};
